import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../Layout/Layout';
import Currency from '../pages/sb/currency/currencyIndex';
import SystemSettings from '../pages/system settings';
import Cites from '../pages/sb/cites/citesndex';
import Nationalities from '../pages/sb/nationalities/nationalitiesIndex';

import Company from '../pages/sb/companyFields/companyFiledesIndex';
import Countries from '../pages/sb/countries/countriesIndex';
import Requests from '../pages/sb/requests/requestsIndex';
import CompanySettings from '../pages/companySettings';
import Levels from '../pages/hr/levels/levelseIndex';
import EmpolymentTypes from '../pages/hr/empolymentTypes/empolynentIndex';
import Shifts from '../pages/sb/shifts/shiftsIndex';
import Branches from '../pages/sb/Branches/branchesIndex';
import Employes from '../pages/sb/employes/employesIndex';
import Companies from '../pages/sb/companies/companiesIndex';
import Rules from '../pages/sb/rules/rulesIndex';
import Device from '../pages/sb/device/deviceIndex';
import Departments from '../pages/sb/departments/departmentsIndex';

import Designations from '../pages/hr/designations/designationsIndex';
import Payrolls from '../pages/hr/payrolls/payrollsIndex';
import Attendance from "../pages/hr/attendance/attendanceIndex/index"
import Constracts from '../pages/hr/constracts/constractsIndex';
import Salary from '../pages/hr/salary/salaryIndex';
import Tasks from '../pages/crm/tasks/tasksindex';
import SalariesSettings from '../pages/salariesSettings';
import Profile from '../pages/core/profile';
import ChangePassword from '../pages/core/changepassword';
import EmployeProfile from '../pages/core/employeProfile';
import CompanyRules from '../pages/sb/companyRules/companyRulesIndex';
import Pages from '../pages/sb/pages/pagesIndex';
import Articles from '../pages/sb/articles/articlesIndex';
import Categories from '../pages/sb/categories/categoriesIndex';


const LayoutRoutes = () => {

  return (
    <>
      <Routes>
 
        {routes.map(({ path, Component }, i) => (
          <Route element={<AppLayout />} key={i}>     
          <Route path={`${process.env.PUBLIC_URL}/systemsettings`} element={<SystemSettings  />}>
          <Route index element={<Navigate to={`${process.env.PUBLIC_URL}/systemsettings/currencies`} />} />
              
              <Route  path="currencies" element={<Currency />} />
              <Route path="countries" element={<Countries />} />
              <Route path="cities" element={<Cites />} />
              <Route path="nationalities" element={<Nationalities />} />
              <Route path="companies" element={<Companies />} />
              <Route path="company-fields" element={<Company />} />
              <Route path='pages' element={<Pages/>}/>
              <Route path="rules" element={<Rules />} />
              <Route path='articles' element={<Articles/>}/>
              <Route path='categories' element={<Categories/>}/>
            </Route>


            <Route path={`${process.env.PUBLIC_URL}/companysettings`} element={<CompanySettings  />}>
          <Route index element={<Navigate to={`${process.env.PUBLIC_URL}/companysettings/levels`} />} />
              <Route   path='companyrules' element={ <CompanyRules />} />
              <Route  path="levels" element={<Levels />} />
              <Route  path="empolymentTypes" element={<EmpolymentTypes />} />
              <Route path="shifts" element={<Shifts />} />
              <Route path="branches" element={<Branches />} /> 
              <Route path="requests" element={<Requests />} />
              <Route path="employes" element={<Employes />} />
              <Route path="departments" element={<Departments />} />
              <Route path="device" element={<Device />} />
       
              <Route path="attendance" element={<Attendance />} />
              <Route path="designations" element={<Designations />} />
              <Route path="tasks" element={<Tasks />} />
           
            </Route>  
             
            <Route path={`${process.env.PUBLIC_URL}/salariesSettings`} element={<SalariesSettings  />}>
              <Route index element={<Navigate to={`${process.env.PUBLIC_URL}/salariesSettings/salary`} />} />
               <Route path="payrolls" element={<Payrolls />} />
              <Route path="salary" element={<Salary />} />
              <Route path="constracts" element={<Constracts />} />
         
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/user`} element={<Profile  />}>
              <Route index element={<Navigate to={`${process.env.PUBLIC_URL}/user/profile`} />} />
               <Route path="profile" element={<EmployeProfile/>} />
              <Route path="changepassword" element={<ChangePassword />} />        
            </Route>
            
            <Route path={path} element={Component} />
          </Route>
        ))}
      </Routes>
    </>
  );
};

export default LayoutRoutes;